import { overrideImplementation } from '@wix/editor-platform-sdk-implementation';
import { getWorkerManager, init } from './bootstrap/init';
import {
  onSetAppPublicAPI,
  setEditorAPI,
} from './bootstrap/platformPostMessageService';
import { getPlatformizedComponentData } from './services/PlatformizedComponentsService';
import * as canvasOverlayService from './services/canvasOverlayService';
import {
  getComponentApp,
  handleEssentialsComponentsBeforeDelete,
} from './services/componentService';
import {
  createDependenciesDriver,
  installApps,
} from './services/installServiceEditor';
import * as pageReplaceService from './services/pageReplaceService/pageReplaceService';
import { openAddElementsPanelIfExist } from './services/platformPanelsService';
import {
  autoInstall,
  autoInstallWithNavigation,
} from './services/plugins/pluginAutoPopulateService';
import {
  isSilentInstallRunning,
  silentInstall,
} from './services/silentInstallService';
import * as slotsService from './services/slotsService';
import * as toolsEntryService from './services/toolsEntryService';
import {
  getComponentIdentifiers,
  isComponentEssentialByRef,
  isPageDuplicatable,
  isPageEssential,
  isWidgetStretchable,
} from './services/unifiedComponents/componentSettings';
import * as viewStateService from './services/viewStateService';
import { EditActionsStore } from './services/editActionsServices';
import { ActionExecutionStore } from './services/editActionsServices/actionExecutionStore';
import { appMarketService } from './utils/appMarketService';
import { getGroups } from './services/addPanelService/addPanelService';

const API = {
  init,
  setEditorAPI,
  applications: {
    setAppPublicAPI: onSetAppPublicAPI,
    createDependenciesDriver,
    install: installApps,
    fetchNames: appMarketService.fetchAppsNames,
    silentInstall,
    isSilentInstallRunning,
  },
  getWorkerManager,
  pages: {
    isPageEssential,
    isPageDuplicatable,
  },
  components: {
    getComponentApp,
    handleEssentialsComponentsBeforeDelete,
    getPlatformizedComponentData,
    isWidgetStretchable,
    getComponentIdentifiers,
    isComponentEssentialByRef,
  },
  sdk: {
    overrideImplementation,
  },
  pageReplace: {
    ...pageReplaceService,
  },
  canvasOverlay: {
    hideAll: () => {
      canvasOverlayService.overlayStore.hideAll();
    },
    unhideAll: () => {
      canvasOverlayService.overlayStore.unhideAll();
    },
  },
  viewState: viewStateService,
  toolsEntry: toolsEntryService,
  slots: {
    getPluginInstallationParams: slotsService.getPluginInstallationParams,
    getAllPluginsInstallationParams:
      slotsService.getAllPluginsInstallationParams,
    autoInstall: {
      install: autoInstall,
      installWithNavigation: autoInstallWithNavigation,
    },
  },
  panels: {
    addElements: {
      openIfExist: openAddElementsPanelIfExist,
    },
    addPanel: {
      getGroups,
    },
  },
  editActions: {
    contributeHostActions: EditActionsStore.contributeActions,
    contributeExecutionMethods: ActionExecutionStore.contributeExecutionMethods,
  },
};

export default API;
